// extracted by mini-css-extract-plugin
module.exports = {"card":"IntItem_card__3ZeL4","image":"IntItem_image__13baJ"};